import 'bootstrap/dist/css/bootstrap.min.css';
import './MiniatureList.css';
import axios from 'axios';
import { DATASET, globalSetDataset } from '../pages/Global.js';
import React, { useState, useEffect } from 'react';





const MiniatureList = ({ csvData, currentCsvIndex, onSelect, validations }) => {

    const [imageURLs, setImageURLs] = useState({}); // Un objet pour stocker les URLs des images

  // console.log('csvData (miniature list):', csvData.map(p => ({ csvIndex: p.csvIndex, name1: p.name1, name2: p.name2 })));

    //ùùùùùùùùùùùùùùùùùùùùùùùùùùùùùùùùùùùùùùùùùùùùùùùùùùùùùùùù
  return (
    <div className="miniature-list">
      <ul className="list-group">
      {/* <ul className="dataset-list"> */}
      {csvData.map((result) => {
          // Trouver l'indice original de l'élément dans originalData
          // const originalIndex = originalData.indexOf(result);
          // const originalIndex = originalData.findIndex(
          //     (item) => item.name1 === result.name1 && item.name2 === result.name2
          //   );
          const originalIndex = result.csvIndex;

          const name1 = result.name1 || '';
          const name2 = result.name2 || '';
          const distance = result.distance ? parseFloat(result.distance) : 0;


          // Get validation status color
          const getStatusColor = (validation) => {
            switch(validation) {
              case 1: return 'bg-success';
              case 0.75: return 'bg-primary';
              case 0.5: return 'bg-secondary';
              case 0.25: return 'bg-warning';
              case 0: return 'bg-danger';
              default: return 'bg-light';
            }
          };

          return (
            <li
            key={result.csvIndex}
            className={`list-group-item ${result.csvIndex === currentCsvIndex ? 'active' : ''}`}
            onClick={() => {
              console.log('[MiniatureList] Click csvIndex:', result.csvIndex, result.name1, result.name2);
              onSelect(result.csvIndex);
            }}
            style={{ cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
            >
            <div className="row align-items-center">
              <div className="col-auto">
                <span className="index-number">{result.csvIndex + 1}</span>
              </div>
              <div className="col d-flex flex-column">
                <div className="w-100 text-center mt-1">
                  <span className="text-truncate" style={{ display: 'block', fontSize: '10px' }}>
                    {result.name1}
                  </span>
                  <span className="text-truncate" style={{ display: 'block', fontSize: '10px' }}>
                    {result.name2}
                  </span>
                </div>
              </div>
            </div>
            <div className="validation-indicator">
              <div className={`status-square ${getStatusColor(validations[result.csvIndex])}`}></div>
            </div>
          </li>           
          );
        })}
      </ul>
    </div>
  );
};

export default MiniatureList;
